import { debug as _debug, Rgb } from '@schibsted-nmp/advertising-shared';

export const label = 'RelevantYield';

export const debug = _debug.withLabel(label, Rgb.red, Rgb.white);
